import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IncidentFormControls } from '../../../../../types';

@Component({
  selector: 'app-review-form-errors-inline-alert',
  templateUrl: './review-form-errors-inline-alert.component.html',
  standalone: false,
})
export class ReviewFormErrorsInlineAlertComponent {
  public form = input.required<FormGroup<IncidentFormControls>>();
}
